const platformAdmin = {
  app: {
    title: 'AIONA Platform Admin',
    signOut: 'Sign out',
    menuLabel: 'Administration menu',
    tenantsNav: 'Tenants',
    auditLog: 'Operation history',
  },
  login: {
    prompt: 'Sign in with Entra ID.',
    signIn: 'Sign in with Entra ID',
  },
  environment: {
    label: 'Environment',
    loadingSettings: 'Loading environment settings…',
    readOnly: 'This environment is read-only.',
    demo: 'Demo',
    production: 'Production',
    heading: 'Environment: {{environment}}',
    checkingAccess: '{{environment}} access is being checked…',
  },
  common: {
    notVerified: 'Not verified',
    loadingOption: 'Loading',
    status: 'Status',
    expires: 'Expiration',
    loading: 'Loading…',
    operation: 'Operation',
    reason: 'Reason',
    reviewDetails: 'Review details',
    cancel: 'Cancel',
    none: 'None',
  },
  lifecycle: {
    active: 'Active contract',
    trial: 'Trial',
    suspended: 'Suspended',
    archived: 'Archived',
  },
  usage: {
    fresh: 'Aggregation complete',
    stale: 'Usage is not verified because the aggregation is stale',
    unaggregated: 'Usage is not verified because the required period has not been aggregated',
    definition: 'Feature counts: audit events over 7 days. Active users: distinct users over 7 days. Per-user counts: 30 days.',
    summary: '{{status}}  / Last successful run: {{completedAt}}  / Aggregated through:  {{coveredUntil}}',
  },
  tenants: {
    title: 'Tenants',
    empty: 'No tenants.',
    name: 'Tenant name',
    events7d: 'Usage events over 7 days',
    eventCount: '{{events}} events',
  },
  detail: {
    contractSection: 'Contract and contacts',
    featureUsageTitle: 'Feature usage over 7 days',
    activeUsers: 'Active users',
    recentActivity: 'Recent activity',
    userUsageTitle: 'Per-user usage (30-day audit events)',
    user: 'User',
    userEventCount: 'Event count',
    savedDataTitle: 'Stored data',
    codeAndEnvironment: '{{code}}  / Environment: {{environment}}',
    statusLine: 'Status: {{status}}  / Expiration:  {{expires}}',
    owners: 'Contact: {{owner}} {{separator}} CS: {{cs}}  / Sales: {{sales}}',
    activeUsersCount: '{{users}} users',
    savedDataSummary: 'Chat{{threads}} threads /  {{messages}} messages / DRBFM  {{drbfmSessions}} events',
  },
  features: {
    search: 'Search',
    chat: 'Chat',
    drbfm: 'DRBFM',
    cad: 'CAD',
    upload: 'Upload',
    failures: 'Failures',
  },
  events: {
    empty: 'No records.',
    createdAt: 'Date and time',
    result: 'Result',
    admin: 'Administrator',
  },
  operations: {
    actions: {
      extendTrial: 'Extend expiration',
      suspend: 'Suspend',
      reactivate: 'Reactivate (active contract)',
      dataCleanup: 'Delete selected data',
    },
    title: 'Administrative operations',
    chatHistory: 'Chat history',
    cleanupNotice: 'Uploaded documents are excluded. Deletion cannot be undone.',
    dialogLabel: 'Confirm administrative operation',
    running: 'Running…',
    confirmTitle: '{{action}} confirmation',
    targetLine: 'Environment: {{environment}}  / Tenant: {{tenant}} ({{code}})',
    reasonLine: 'Reason: {{reason}}',
    expiresLine: 'Expiration: {{expires}}',
    deleteTargets: 'Delete: {{targets}}',
    runIn: '{{environment}} — execute',
  },
  trial: {
    title: 'New trial',
    companyName: 'Company name',
    tenantCode: 'Tenant code',
    initialAdminEmail: 'Initial administrator email',
    ownerEmail: 'Contact email',
    csOwnerEmail: 'Customer success email',
    salesOwnerEmail: 'Sales email',
    notes: 'Notes',
    dialogLabel: 'Confirm trial creation',
    summary: '{{company}} ({{code}}) {{separator}} {{email}}  / Expiration:  {{expires}}',
    featuresLine: 'Features: {{features}}',
    createIn: '{{environment}} — create',
  },
  errors: {
    loadFailed: 'Could not load the data.',
    microsoftSignInIncomplete: 'Microsoft sign-in did not finish. Please sign in again.',
    authNotVerified: 'Could not verify authentication. Please sign in again.',
    entraNotConfigured: 'Entra ID is not configured. Contact an administrator.',
    writesNotPermitted: 'Changes are not permitted in this environment.',
    invalidEnvironmentConfig: 'The admin API environment configuration is invalid.',
    currentEnvironmentMissing: 'The current environment is not configured.',
    environmentMismatch: 'The selected environment does not match the admin API.',
    requestFailed: 'Cannot access the admin API ({{status}}). Check authentication, permissions and connectivity for the selected environment.',
  },
};
export default platformAdmin;
